import { Injectable } from '@angular/core';
import { AuthService } from '../../../shared/services/auth.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { UtilService } from 'src/app/shared/services/util.service';
import { ApiService } from 'src/app/shared/services/api.service';

@Injectable({
  providedIn: 'root'
})
export class MergeBookingService {

  constructor(private authService: AuthService, private commonService: CommonService, private utilService: UtilService,
              private apiService: ApiService) {

  }

  getMergeRequest(bookings, formGroup, ridersMap) {

    const bookingRequest: any = {
      spotBookings: []
    };
    const mergeRequest = {
      bookingIds: [],
      bookingRequest
    };

    // set requester object
    const user = this.authService.user.info.employee;
    mergeRequest.bookingRequest.requester = {
      emplGuid: user.guid,
      name: user.employeeName,
      emplId: user.employeeId,
      email: user.emailId,
      gender: user.gender,
      mobile: user.phone,
      buid: this.authService.user.buId
    };
    mergeRequest.bookingRequest.bookerBuid = this.authService.user.buId;
    mergeRequest.bookingRequest.client = this.authService.client.client,

    mergeRequest.bookingRequest.bookerGuid = this.authService.user.employeeGuid;

    // setup booking object
    const bookingObj: any = {
      otherDetails: '',
      reason: '',
      flightDetails: ''
    };

    for (const booking of bookings) {
      mergeRequest.bookingIds.push(booking.bookingId);
      bookingObj.otherDetails = this.utilService.appendStringWithCommaSeperator(bookingObj.otherDetails, booking.otherDetails);
      bookingObj.reason = this.utilService.appendStringWithCommaSeperator(bookingObj.reason, booking.reason);
      bookingObj.flightDetails = this.utilService.appendStringWithCommaSeperator(bookingObj.flightDetails, booking.flightDetails);
      if (booking.guardReq){
        formGroup.get('bookingDetails').get('guardReq').setValue(true);
      }
    }

    bookingObj.city = bookings[0].city;
    bookingObj.destinationCity = bookings[0].destinationCity;

    const bookingFormDetails = formGroup.get('bookingDetails').getRawValue();
    Object.assign(bookingObj, bookingFormDetails);
    bookingObj.vehicleType = bookingObj.vehicleType === 'Other' ? bookingObj.otherVehicleType : bookingObj.vehicleType;
    delete bookingObj.otherVehicleType;

    for (const vendor of this.commonService.etsData.vendors) {
      if (bookingObj.vendor === vendor.guid) {
        bookingObj.vendor = vendor;
        break;
      }
    }
    bookingObj.vendor  = bookingObj.vendor || null;
    for (const cab of this.commonService.etsData.cabs) {
      if (bookingObj.cab === cab.guId) {
        bookingObj.cab = cab;
        break;
      }
    }
    if (bookingObj.cab === '') {
      bookingObj.cab = null;
    }

    // add in stop info
    const formStops = formGroup.get('stopsArray').getRawValue();
    const stops = [];
    const riderTrack = [];
    const riderDropTrack = [];
    const allRiders = [];
    formStops.forEach((stop, stopIndex) => {
      const stopObj: any = Object.assign({}, stop.address);
      stopObj.priorityOrder = stopIndex + 1;
      if (stop.time) {
        stopObj.time = this.utilService.convertToDateTimeString(stop.date[0], stop.time);
      }

      const travellers = [];
      if (stop.riders) {
        for (const rider of stop.riders) {
          if (!ridersMap[rider.name]) {
            continue;
          }
          if (rider.boardingType === 'PickUp') {
            riderTrack.push(rider.name);
          } else if (rider.boardingType === 'Drop') {
            riderDropTrack.push(rider.name);
          }
          allRiders.push(rider.name);
          const riderDetails = this.utilService.deepCopy(ridersMap[rider.name]);
          riderDetails.boardingType = rider.boardingType;
          travellers.push(riderDetails);
        }
      }
      stopObj.riders = travellers;

      switch (stopIndex) {
        case 0: stopObj.pointType = 'START'; break;
        case formStops.length - 1: stopObj.pointType = 'END'; break;
        default: stopObj.pointType = '';
      }
      stops.push(stopObj);
    });

    const stopRiders = stops[stops.length - 1].riders;
    for (const riderId of riderTrack) {
      if (riderDropTrack.indexOf(riderId) < 0) {
        const riderObj = this.utilService.deepCopy(ridersMap[riderId]);
        riderObj.boardingType = 'Drop';
        stopRiders.push(riderObj);
      }
    }

    const startRiders = stops[0].riders;
    for (const riderId of riderDropTrack) {
      if (riderTrack.indexOf(riderId) < 0) {
        const riderObj = this.utilService.deepCopy(ridersMap[riderId]);
        riderObj.boardingType = 'PickUp';
        startRiders.push(riderObj);
      }
    }

    Object.keys(ridersMap).forEach((riderId: string) => {
      if (allRiders.indexOf(riderId) < 0) {
        const riderObj = this.utilService.deepCopy(ridersMap[riderId]);
        const riderObj2 = this.utilService.deepCopy(ridersMap[riderId]);
        riderObj.boardingType = 'Drop';
        stopRiders.push(riderObj);
        riderObj2.boardingType = 'PickUp';
        startRiders.push(riderObj2);
      }
    });
    bookingObj.stops = stops;
    bookingObj.startTime = stops[0].time;
    mergeRequest.bookingRequest.spotBookings.push(bookingObj);
    return mergeRequest;
  }

  mergeBookings(request) {
    return this.apiService.httpRequest({
      url: 'mergeBooking',
      type: 'POST',
      body: request
    });
  }
}
